module.exports = __webpack_public_path__ + "img/mm-exchange.3e7ed43c.png";